<!-- ═══════════════════════════════════════════════════
     NORMAL TABLE VIEW (Default — before any row click)
     ═══════════════════════════════════════════════════ -->
<div *ngIf="!showMasterDetail && !showSplitViewOnly" class="master-table-view">
  <mat-card class="mat-elevation-z24">
    <mat-card-content>
      <app-reusable-table
        [columns]="masterColumns"
        [data]="masterServerSidePagination ? masterData : paginatedMasterData"
        [clickableRows]="!disableRowClick"
        [pagination]="masterPagination"
        [sortable]="masterSortable"
        [stickyHeader]="true"
        [rowHeight]="40"
        [cellTemplates]="masterCellTemplates"
        [paginatorSelectConfig]="{ panelClass: 'md-paginator-select-panel' }"
        (rowClick)="disableRowClick ? null : onMasterRowClick($event)"
        (pageChange)="onMasterPageChange($event)"
        (sortChange)="onMasterSortChange($event)">
      </app-reusable-table>
    </mat-card-content>
  </mat-card>
</div>

<!-- ═══════════════════════════════════════════════════
     MASTER-DETAIL VIEW (After clicking a row)
     ═══════════════════════════════════════════════════ -->
<div *ngIf="showMasterDetail" class="master-detail-view" #masterDetailContainer fxLayout="row" fxLayoutGap="0px">

  <!-- LEFT PANEL: Master summary list -->
  <div [fxFlex]="leftPanelFlex" fxFlex.lt-md="100">
    <mat-card class="mat-elevation-z24 left-panel-card">

      <!-- Header -->
      <div class="left-panel-header">
        <h3 class="left-panel-title">{{ leftPanelTitle }}</h3>
      </div>

      <!-- Scrollable list -->
      <mat-card-content class="left-panel-content">
        <div class="left-panel-list" #listContainer>
          <div
            #listItem
            *ngFor="let row of paginatedMasterData"
            class="list-item-wrapper"
            [class.selected]="isRowSelected(row)">
            <div class="list-item"
                 [class.selected]="isRowSelected(row)"
                 [class.expanded]="isRowSelected(row) && summaryExpanded && summaryConfig.summaryFields?.length"
                 [class.has-secondary]="getSecondaryText(row)"
                 (click)="onMasterRowClick(row)">
              <div class="list-item-info">
                <div class="list-item-primary">{{ getPrimaryText(row) }}</div>
                <div class="list-item-secondary" *ngIf="getSecondaryText(row)">
                  {{ getSecondaryText(row) }}
                </div>
              </div>
            </div>
            <!-- Summary fields for selected item (collapsible) -->
            <div class="list-item-summary"
                 *ngIf="isRowSelected(row) && summaryExpanded && summaryConfig.summaryFields?.length">
              <div class="summary-field" *ngFor="let sf of summaryConfig.summaryFields" [class.summary-field-split-columns]="sf.displayMode === 'split-text-amount'">
                <span class="summary-field-label">{{ sf.displayMode === 'split-text-amount' ? getSplitSummaryLeftBlock(row, sf) : sf.label }}</span>
                <span class="summary-field-value">{{ sf.displayMode === 'split-text-amount' ? getSplitSummaryRightBlock(row, sf) : formatSummaryValue(row, sf) }}</span>
              </div>
            </div>
          </div>

          <div *ngIf="!masterData || masterData.length === 0" class="no-data">
            <p>No records found</p>
          </div>
        </div>
      </mat-card-content>

      <!-- Left panel paginator -->
      <mat-paginator
        *ngIf="!hideLeftPaginator && masterPagination"
        [length]="masterPagination.totalRows"
        [pageIndex]="masterPagination.pageIndex"
        [pageSize]="masterPagination.pageSize"
        [pageSizeOptions]="masterPagination.pageSizeOptions || [10, 25, 50, 100]"
        [selectConfig]="{ panelClass: 'md-paginator-select-panel' }"
        aria-label="Select page"
        (page)="onMasterPageChange($event)">
      </mat-paginator>
    </mat-card>
  </div>

  <!-- RESIZE HANDLE -->
  <div class="panel-resize-handle" (mousedown)="onPanelResizeStart($event)"></div>

  <!-- RIGHT PANEL: Detail table -->
  <div [fxFlex]="rightPanelFlex" fxFlex.lt-md="100">
    <mat-card class="mat-elevation-z24 right-panel-card">
      <div *ngIf="selectedRow" class="right-panel-inner">

        <!-- Header with title + close button -->
        <div class="right-panel-header">
          <h2 class="right-panel-title">{{ getDetailHeader() }}</h2>
          <button *ngIf="!showSplitViewOnly" mat-icon-button (click)="closeDetail()" matTooltip="Close" class="close-btn">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <!-- Custom detail content template -->
        <div *ngIf="detailContentTemplate" class="right-panel-table-area">
          <ng-container *ngTemplateOutlet="detailContentTemplate; context: { $implicit: selectedRow }"></ng-container>
        </div>

        <!-- Detail table (default when no custom template) -->
        <div *ngIf="!detailContentTemplate" class="right-panel-table-area">
          <app-reusable-table
            [columns]="detailColumns"
            [data]="detailData"
            [pagination]="detailPagination"
            [sortable]="detailSortable"
            [stickyHeader]="true"
            [cellTemplates]="detailCellTemplates"
            [paginatorSelectConfig]="{ panelClass: 'md-paginator-select-panel' }"
            (pageChange)="onDetailPageChange($event)"
            (sortChange)="onDetailSortChange($event)">
          </app-reusable-table>
        </div>
      </div>

      <!-- Placeholder when nothing selected -->
      <div *ngIf="!selectedRow" class="no-selection">
        <mat-icon class="no-selection-icon">table_chart</mat-icon>
        <h3>Select a record</h3>
        <p>Click a row on the left to view details</p>
      </div>
    </mat-card>
  </div>
</div>
